import { useContext, useMemo } from "react";
import { AuthContext } from "../context/Auth/AuthContext";

const useCompanySipEnabled = () => {
  const { user } = useContext(AuthContext);
  const companySipInUser = user?.company?.sipEnabled;
  const isSupportSessionActive = Boolean(user?.supportSession?.active);
  const isPureSuperAdmin = user?.profile === "superadmin" && !isSupportSessionActive;

  const sipEnabled = useMemo(() => {
    if (isPureSuperAdmin) {
      return true;
    }

    if (typeof companySipInUser === "boolean") {
      return companySipInUser;
    }

    return true;
  }, [companySipInUser, isPureSuperAdmin]);

  return {
    sipEnabled,
    loading: false
  };
};

export default useCompanySipEnabled;
